import { h } from '../pragma.mjs';

export default (aktivni) => {
    
    return (
        <gov-tabs-item id="situace" label="Životní situace" default={aktivni} role="tab">

            <div id="SituaceTab" class="tabcontent" role="tabpanel">
                <div class="sides-auto">
                    <div class="vdp-col-12">

                        <div id="logininvitation">
                            <div class="left-column">
                            <h2 role="heading" aria-level="2">Portál katastru a zeměměřictví</h2>
                            <br />
                            <gov-chip inverse="false" icon-left="basic/coins" variant="primary" size="xl">
                            Podání návrhu na vklad prostřednictvím tohoto portálu je spojeno se snížením správního poplatku o 20&nbsp;%.
                            </gov-chip>

                            <gov-chip inverse="false" variant="" size="xl">Nejrychlejší cesta ke službám úřadu.</gov-chip>

                            <br />
                            
                            <gov-button id="loginButton" href="#" variant="secondary" slot="btn" type="solid" size="m" wcag-label="Přihlášení uživatele">
                                Přihlásit do portálu
                            </gov-button>

                            </div>
                            <div class="right-column">
                                <img src="/assets/govczdesign/icons/complex/region.svg" alt="Region Icon" role="img" wcag-label="Region Icon" />
                            </div>
                        </div>

                        <a id="situace-anchor"></a> {/* Anchor added here */}
                        <h1 role="heading" aria-level="1">Vyberte životní situaci, ve které se nacházíte</h1>
                    </div>

                    <div id="tiles" class="situace-block" role="list">
                        {/*import karty.jsx using rozcestnikService.js*/}
                    </div>
                </div>
            </div>
        </gov-tabs-item>
    )
}